import styled from 'styled-components'
export const NOCWrapper = styled.div`
  padding-top: 0px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 75vh;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  .new-top {
    margin-top: 20px;

    span {
      color: ${({ theme }) => theme.colors.navyBlue};
    }
  }
  .first {
    margin-top: -20px;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  & {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  .blur {
    background-color: #6e7191;
    opacity: 1;
  }
  h1 {
    font-family: ${({ theme }) => theme.fontFamily.visuelt};
    font-style: normal;
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x1};
    line-height: 32px;
  }
  .minus {
    margin-top: -10px;
  }

  .select_input {
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 100%;
    }
  }

  h6 {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.DarkCyan};
    margin-top: -10px;
  }
  span {
    font-size: ${({ theme }) => theme.fontSize.x2};
    line-height: 24px;
    letter-spacing: 0.75px;
    color: ${({ theme }) => theme.colors.Gprimary};
    font-weight: 500;
  }
  .form-group-select {
    /* margin-top: 20px; */
  }
  input {
    margin-top: -20px;
  }
  .amount {
    margin-bottom: 20px;
  }
  .height {
    height: 50px;

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 100%;
    }
  }
  .full-height {
    height: 90%;
    overflow-y: scroll;
    ::-webkit-scrollbar {
      display: none;
    }
  }
  .register-select {
    margin-top: -25px;
  }
`
export const FormContainer = styled.form`
  .form-group {
    position: relative;
    margin-bottom: 25px;
  }

  .form-group.has-error input {
    border: 1px solid red;
  }

  .form-group.has-error .error-icon {
    display: block;
  }

  .error-icon {
    position: absolute;
    top: 12px;
    right: 0px;
    font-size: 24px;
    display: none;
    color: red;
  }
  .filter_select {
    margin-top: -5px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 100%;
    }
  }
  .error-text {
    text-align: left;
    margin: 0 26px;
    padding-top: 4px;
    text-transform: capitalize;
    color: red;
    font-size: ${({ theme }) => theme.fontSize.s};
  }

  .form-group input:focus {
    border: 1px solid blue;
  }
`
export const Wrapper = styled.form`
  /* padding-top: 13px; */
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  display: flex;
  flex-direction: column;
  height: 92vh;

  p {
    font-size: ${({ theme }) => theme.fontSize.s};
    line-height: 24px;
    letter-spacing: 0.75px;
    color: ${({ theme }) => theme.colors.gray};
    opacity: 0.8;
    margin-top: -15px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      margin-top: -10px;
    }
  }
  .blur {
    background-color: #6e7191;
    opacity: 1;
  }
  .top {
    margin-top: 52px;
  }
  .tops {
    margin-top: 33px;
  }
  .wallet {
    font-size: ${({ theme }) => theme.fontSize.xx2};
  }
  h4 {
    font-size: ${({ theme }) => theme.fontSize.x2};
    line-height: 4px;
    color: ${({ theme }) => theme.colors.NeutralBlack};
    opacity: 0.6;
    font-family: ${({ theme }) => theme.fontFamily.inter};
  }
  .destination,
  .amount {
    margin-top: 0px;
  }
  input {
    margin-top: -10px;
  }
  .line {
    height: 3px;
    width: auto;
    background: ${({ theme }) => theme.colors.grey};
    margin: 0px -47px;
  }
  /* .css-b62m3t-container {
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid #858c94;
    box-sizing: border-box;
    border-radius: 8px;
    height: 60px;
  }
  .css-1s2u09g-control {
    height: 60px;
  }
  .css-14dclt2-Input {
    font-size: 14px;
    line-height: 24px;
    color: #6e7191;
    opacity: 0.8;
    padding-left: 16px;
  }
  .css-1okebmr-indicatorSeparator {
    background-color: transparent;
  }
  .css-1hb7zxy-IndicatorsContainer {
    border-bottom: 1px solid #858c94;
  }
  .css-319lph-ValueContainer {
    height: 60px;
    border-bottom: 1px solid #858c94;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  } */
  .cancel {
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.CollaboBlue};
    border: 1px solid ${({ theme }) => theme.colors.CollaboBlue};
  }
  .confirm {
    margin: 2px 0px;
  }
  .note {
    margin-top: 15px;
  }
  .choose {
    font-size: ${({ theme }) => theme.fontSize.x4};
    line-height: 14px;
    color: ${({ theme }) => theme.colors.dark};
    /* margin-top:20px; */
  }

  .height {
    height: 50px;
  }
`
